import { render, staticRenderFns } from "./FeedbackWidget.vue?vue&type=template&id=ca59c5c8&scoped=true"
import script from "./FeedbackWidget.vue?vue&type=script&lang=ts"
export * from "./FeedbackWidget.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackWidget.vue?vue&type=style&index=0&id=ca59c5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca59c5c8",
  null
  
)

export default component.exports